import { apiService, createRequestHeadersConfig } from 'shared/api'

import type { DiscountCode } from './types'

const api = apiService()

export const getDiscountCodes = (payload: {
  token?: string
}): Promise<{ data: { data: DiscountCode[] } }> =>
  api.get('/discount-codes', createRequestHeadersConfig(payload.token))
